<div class="ex-backdrop" *ngIf="isOpen" (click)="close()">
  <div class="ex-modal" (click)="$event.stopPropagation()">

    <!-- ── Header ─────────────────────────────────────────────────── -->
    <div class="ex-header">
      <div class="ex-header__left">
        <div class="ex-header__icon-wrap">
          <img [src]="headerIconSrc" [alt]="headerTitle" class="ex-header__icon" />
        </div>
        <h2 class="ex-header__title">{{ headerTitle }}</h2>
      </div>
      <div class="ex-header__actions">
        <button class="ex-header__btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
        </button>
        <button class="ex-header__btn ex-header__btn--close" (click)="close()">✕</button>
      </div>
    </div>

    <!-- ── Body ───────────────────────────────────────────────────── -->
    <div class="ex-body">

      <!-- ── Left Column ─────────────────────────────────────────── -->
      <div class="ex-col ex-col--left">

        <!-- XP Tiers Card -->
        <div class="ex-tiers-card">
          <div class="ex-tiers__row">
            <img src="assets/performance/hse-tiers-banner.svg" alt="HSE Tiers"/>
          </div>
          <p class="ex-xp-points-text">{{ progressBarPointsText }}</p>
          <div class="ex-xp-bar-row">
            @if (leftIcon) {
              <img [src]="leftIcon" class="ex-xp-icon" alt="" />
            } @else {
              <div class="ex-xp-icon"></div>
            }
            <div class="ex-xp-track">
              <div class="ex-xp-fill"
                [style.width]="progressBarWidth"
                [style.background]="progressBarGradient">
                @if (showProgressDot) {
                  <span class="ex-xp-dot" [style.background]="progressBarDotColor"></span>
                }
              </div>
            </div>
            <img [src]="rightIcon" class="ex-xp-icon ex-xp-icon--right" alt="" />
          </div>
          <p class="ex-xp-label">{{ progressBarLabel }}</p>
        </div>

        <!-- Performance Card -->
        <div class="perf-detail-card">
          <div class="perf-detail-hdr" [style.background]="performanceCardHeader.bg">
            <img [src]="performanceCardHeader.iconSrc" class="ex-card-header__icon" alt="" />
            <span class="perf-detail-hdr-title">{{ performanceCardHeader.title }}</span>
          </div>
          <div class="perf-score-center">
            <div class="perf-score-main">
              <span class="perf-score-number" [style.color]="performanceScoreColor">{{ performanceScore }}</span>
              <span class="perf-score-points-label">Points</span>
            </div>
            <p class="perf-score-sub">{{ "BASED_ON_YOUR_MONTH_FITNESS_SCORE" | translate }}</p>
          </div>
          <div class="perf-h-divider"></div>
          <div class="perf-detail-bottom">
            <div class="perf-months-col">
              @for (m of performanceMonths; track $index) {
                <div class="perf-month-row">
                  <span class="perf-month-name">{{ m.month }}</span>
                  <span class="perf-month-pts">{{ m.val }}</span>
                </div>
              }
            </div>
            <div class="perf-total-row">
              <span class="perf-total-val">{{ performanceTotalLabel }}</span>
            </div>
          </div>
        </div>

        <!-- Engagement Card -->
        <div class="perf-detail-card">
          <div class="perf-detail-hdr" [style.background]="engagementCardHeader.bg">
            <img [src]="engagementCardHeader.iconSrc" class="ex-card-header__icon" alt="" />
            <span class="perf-detail-hdr-title">{{ engagementCardHeader.title }}</span>
          </div>
          <div class="perf-score-center">
            <div class="perf-score-main">
              <span class="perf-score-number" [style.color]="engagementScoreColor">{{ engagementScore }}</span>
              <span class="perf-score-points-label">Points</span>
            </div>
            <p class="perf-score-sub">based on your month field contribution</p>
          </div>
          <div class="perf-h-divider"></div>
          <div class="perf-detail-bottom">
            <div class="perf-months-col">
              @for (m of engagementMonths; track $index) {
                <div class="perf-month-row">
                  <span class="perf-month-name">{{ m.month }}</span>
                  <span class="perf-month-pts">{{ m.val }}</span>
                </div>
              }
            </div>
            <div class="perf-total-col">
              <span class="perf-total-val">{{ engagementTotalLabel }}</span>
              <button class="eng-top5-btn" (click)="openEngagedUnitsTop5()">
                <img src="assets/performance/engaged-units-trophy.svg" alt="" class="eng-top5-btn__icon" />
                <span>Top 5 Engaged units</span>
                <span class="eng-top5-btn__arrow">›</span>
              </button>
            </div>
          </div>
        </div>

      </div>

      <!-- ── Right Column ────────────────────────────────────────── -->
      <div class="ex-col ex-col--right">

        <!-- Recognition Card -->
        <div class="ex-section-card">
          <div class="ex-card-header" [style.background]="recognitionCardHeader.bg">
            <img [src]="recognitionCardHeader.iconSrc" class="ex-card-header__icon" alt="" />
            <span class="ex-card-header__title">{{ recognitionCardHeader.title }}</span>
          </div>
          <div class="ex-recognition">
            @if (recognitionItems.length > 0) {
              <div *ngFor="let item of recognitionItems"
                class="ex-recognition__item"
                [class.ex-recognition__item--inactive]="!item.active"
                [class.ex-recognition__item--clickable]="isTop5Item(item) && item.active"
                (click)="isTop5Item(item) && item.active && openTop5Popup(item)">
                <img [src]="item.iconSrc" class="ex-recognition__icon" alt="" (error)="item.iconSrc='assets/performance/award.svg'" />
                <span class="ex-recognition__label">{{ item.label }}</span>
              </div>
            } @else {
              <div class="ex-achievements__empty">
                <p class="ex-achievements__empty-title">No Recognition Available</p>
                <p class="ex-achievements__empty-subtitle">{{ "THERE_IS_CURRENTLY_NO_HSE_RECOGNITION_INFORMATION_TO" | translate }}</p>
              </div>
            }
          </div>
        </div>

        <!-- Past Achievements Card -->
        <div class="ex-past-card">
          <div class="ex-past-card__header">
            <span class="ex-past-card__title">Past Achievements</span>
          </div>
          <div class="ex-achievements">
            @if (achievements.length > 0) {
              @for (a of achievements; track $index) {
                <div class="ex-achievements__row">
                  <div class="ex-achievements__icon-wrap">
                    <img [src]="a.iconSrc" class="ex-achievements__icon" alt="" (error)="a.iconSrc='assets/performance/award.svg'" />
                    @if (a.xp) {
                      <span class="achieve-xp">{{ a.xp | number }} {{ 'XP' | translate }}</span>
                    }
                  </div>
                  <span class="ex-achievements__label">{{ a.label }}</span>
                  <span class="ex-achievements__date">{{ a.date }}</span>
                </div>
              }
            } @else {
              <div class="ex-achievements__empty">
                <p class="ex-achievements__empty-title">No Achievements Available</p>
                <p class="ex-achievements__empty-subtitle">There is currently no Achievements information to display for this selection.</p>
              </div>
            }
          </div>
        </div>

      </div>
    </div>

  </div>
</div>

<!-- Recognition Top 5 Modal -->
<app-recognition-top5-modal
  [isOpen]="top5PopupOpen"
  [title]="top5PopupTitle"
  [headerIcon]="top5PopupIcon"
  [units]="top5PopupUnits"
  (closed)="closeTop5Popup()">
</app-recognition-top5-modal>
